/** Voices offered in the picker, per language — applied on the next call. */
import { getLocale } from "./ui.strings";

export type VoiceOption = { id: string; label: string };

const FR_VOICES: readonly VoiceOption[] = [
  { id: "NEjemlRxgWmL5ZGJetsB", label: "Claire — française, conversationnelle" },
  { id: "i6ke7jvmGEVUyV4zjSaT", label: "Émilie — française, parisienne" },
  { id: "AiJXmyKRr43pvJUsR0tP", label: "Louise — française, chaleureuse" },
  { id: "cgSgspJ2msm6clMCkdW9", label: "Jessica — américaine, chaleureuse" },
  { id: "EXAVITQu4vr4xnSDxMaL", label: "Sarah — américaine, posée" },
];

const ES_VOICES: readonly VoiceOption[] = [
  { id: "dNjJKg63Fr5AXwIdkATa", label: "Cristina — castellana, atención al cliente" },
  { id: "TVZcExm6tc18D9qo57y7", label: "María — castellana, cálida" },
  { id: "gD1IexrzCvsXPHUuT0s3", label: "Sara — castellana, natural" },
];

export const voiceOptions: readonly VoiceOption[] =
  getLocale() === "es" ? ES_VOICES : FR_VOICES;

export const DEFAULT_VOICE_ID = voiceOptions[0]!.id;
export const VOICE_STORAGE_KEY = `nora-voice-${getLocale()}`;
